import React from 'react';
import  StoryTellingGrade1and2  from 'views/StoryTellingGrade1and2';
const BlogNewsroomPage = () => {
return <StoryTellingGrade1and2/>
};
export default BlogNewsroomPage;